import { Container, Stack } from "@mui/material";
import useGetFAQList from "../../../services/welcome/useGetFAQList";
import FAQ from "./faq/FAQ";

const FrequentlyAskedQuestions = () => {
  const titleColor = "#BCBBBE";
  //موقتا کامنت پاک نشود
  //const { data: dataFAQ, error: errorFAQ, loading: loadingFAQ, refetch: refetchFAQ } = useGetFAQList();

  return (
    <Stack
      m={{ xs: 0, lg: 6 }}
      my={{ xs: 3 }}
      direction={{ xs: "column-reverse", md: "row" }}
      spacing={{ xs: 4, lg: 4 }}
      justifyContent="center"
      alignItems="center"
    >
      <Container maxWidth="xl">
        {/* موقتا کامنت پاک نشود */}
        {/* <FAQ id="FAQ" FAQData={dataFAQ} /> */}
      </Container>
    </Stack>
  );
};

export default FrequentlyAskedQuestions;
